import { chat } from "../endpoints/chat.endpoints";
import $axios from "../http/accessor";

const ChatService = {
  getOpenSessions: () => $axios.get(chat.open_sessions),
  getMySessions: () => $axios.get(chat.my_sessions),
  getSession: (session_id: number) =>
    $axios.get(chat.session, { params: { session_id } }),
  sendMessage: (data: {
    session_id: number;
    content?: string;
    attachment_url?: string;
    attachment_type?: string;
  }) => $axios.post(chat.send_message, data),
  claim: (session_id: number) => $axios.post(chat.claim, { session_id }),
  close: (session_id: number) => $axios.post(chat.close, { session_id }),
  upload: (data: FormData) => $axios.post(chat.upload, data),
  markRead: (session_id: number) => $axios.post(chat.read, { session_id }),
};

export default ChatService;
